import styles from './InputFile.module.scss'
import {DeleteFileButtonSVG} from '../../svg/icons/DeleteFileButtonSVG'
import useImageModalStore from 'store/ImageModalStore';

interface Image {
  src: string;
  loading: boolean;
}
type ImagePreviewProps = {
  image: Image;
  onDelete: (src: string) => void;
};

const ImagePreview = ({ image, onDelete }: ImagePreviewProps) => {

  const { setIsShownImage, setSrc } = useImageModalStore();

  const handleImageClick = () => {
    if(!image.loading){
      setIsShownImage(true);
      setSrc(image.src)
    }
  };

  return(
    <>
      <div className={styles.displayImages}>
          {image.loading && (
          <div className={styles.loadingCircleContainer}>
            <div className={styles.loadingCircle}></div>
          </div>
          )}
          <div onClick={() => onDelete(image.src)}>
              <DeleteFileButtonSVG className={styles.deleteImagePreview} width='30' height='30'/>
          </div>
          <img onClick={handleImageClick} className={styles.imagePreview} src={image.src} alt="image-preview"/>
      </div>
    </>
  );
};
  
export default ImagePreview;